import { Component, HostListener, OnInit } from "@angular/core";
import { UserDto } from "../../../api/models/user-dto";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../../../util/service/auth.service";
import { ToastrService } from "ngx-toastr";
import { AuthenticationService } from "../../../api/services/authentication.service";
import { PasswordsMatchValidator } from "../../../util/validator/passwords-match.validator";
import { Observable } from "rxjs";
import { EnumService } from "../../../util/service/enum.service";

@Component({
    selector: "app-own-user-modal",
    templateUrl: "./own-user-modal.component.html",
    styleUrls: ["./own-user-modal.component.scss"],
    standalone: false
})
export class OwnUserModalComponent implements OnInit {
  entity: UserDto;
  formGroup: FormGroup;
  submitted = false;

  public passwordTextType: boolean;
  public confPasswordTextType: boolean;

  constructor(
    public modal: NgbActiveModal,
    public authService: AuthService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private authenticationService: AuthenticationService,
    private enumService: EnumService
  ) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group(
      {
        email: ["", [Validators.required, Validators.email]],
        newPassword: ["", Validators.minLength(5)],
        confirmPassword: [""],
      },
      { validators: [PasswordsMatchValidator.createValidator()] }
    );
    this.formGroup.patchValue(this.entity);
  }

  onSubmit() {
    this.submitted = true;

    if (!this.formGroup.valid) {
      this.toastrService.error("Bitte füllen Sie alle Pflichtfelder aus.", "Speichern fehlgeschlagen");
      return;
    }

    const { newPassword, confirmPassword } = this.formGroup.value;
    let { ...entity } = this.formGroup.value;
    if (newPassword && newPassword === confirmPassword) {
      entity = { ...entity, password: newPassword };
    }
    this.authenticationService.authControllerUpdateMyUser({ body: entity }).subscribe({
      next: (authResult) => {
        this.authService.setAuthResult(authResult);
        this.toastrService.success("Die Kontodaten wurden erfolgreich gespeichert!", "Kontodaten gespeichert");
        this.submitted = false;
        this.modal.close();
      },
      error: (err) => console.error(err),
    });
  }

  /**
   * Toggle password
   */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  /**
   * Toggle confirm password
   */
  toggleConfPasswordTextType() {
    this.confPasswordTextType = !this.confPasswordTextType;
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return !this.formGroup.dirty;
  }
}
